import { Client as ApiClient } from './ApiClient';
import { mapRates } from './Mapping';

const { config }: any = window;

const apiClient = ApiClient(config.apiPath);

export { apiClient, mapRates };
